import React from 'react';

import ProjectProvider from '../projectContext';
import BreadCrumb from '../../../components/Breadcrumbs';
import ProjectWizard from './ProjectWizard';


const ProjectCreationContainer = (props) => {

  const {
    location: { state: {client, announcement} },
  } = props;

  const links = [
    { url: '/clientes', text: 'Clientes' },
    {
      url: '/clientes/detalles',
      text: 'Detalle del cliente',
      state: { client, announcement },
    },
    { text: announcement ? 'Editar convocatoria' : 'Crear convocatoria', url: '.' },
  ];
  return (
    <ProjectProvider>
      <main className="announcement-wizard-page">
        <div className="client__back-container">
          <BreadCrumb links={links} />
        </div>
        <ProjectWizard />
      </main>
    </ProjectProvider>
  );
};

export default ProjectCreationContainer;
